import type { FaireProductEntity } from "../../entity_types/product";

export const p_3km9zxw7a4: FaireProductEntity = {
  token: "p_3km9zxw7a4",
  type: "product",
  name: "CD07391-Floral Puff Sleeve Collared Midi Dress",
  brandToken: "b_51rdlopemv",
  brandName: "TCEC",
  imageUrl:
    "https://cdn.faire.com/fastly/7ec35db6576dca22a1c97d0741d5c64e2a1c3e221c90728d506609cfdf192b89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0ca5f7fc32c511443c994a7d47b2c80427522e17fdd1b572ce9190c68d48fc3.jpeg",
    "https://cdn.faire.com/fastly/9db98ca85fbec84c80a880294a79dd9d8b5be360015e5493651311bc56536064.jpeg",
    "https://cdn.faire.com/fastly/19bc4ec4858121e96926436056c9338f42eaf014e708d6710d19de3c211a8b6c.jpeg",
    "https://cdn.faire.com/fastly/75f1bdff8bc569278f683bc90af8a22ce181187aae4e64ae2dcbeb451aa33a9c.jpeg",
  ],
  priceDollars: 177,
  description:
    "A floral print woven midi dress featuring a collared split neckline and voluminous puff sleeves. Designed with a flattering A-line silhouette, side slits and side pockets for added functionality.\nModel Size + Fit:\nModel height: 5'8\" Dress size: Small Bust: 32 Waist: 24.5 Hips: 35.5",
  tags: [],
  msrpDollars: 354,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:46.390Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
